import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._l((_vm.services),function(service,index){return [_c(VTooltip,{key:index,attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(_vm._s(service.name))])]}}],null,true)},[_c('span',[_vm._v("qty: "+_vm._s(service.quantity))])]),(index != _vm.services.length - 1)?[_vm._v(", ")]:_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }